import {Component, Input, OnInit} from '@angular/core';
import {NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item-logo',
  templateUrl: `sidebar-item-logo.component.html`,
  styleUrls: [`sidebar-item-logo.component.scss`]
})
export class SidebarItemLogoComponent implements OnInit {

  @Input() item?: NavItem;
  @Input() collapsed: boolean;

  T = NavItemsType;
  isEnabled = true;
  enableFullSize = false;

  constructor(private permissionService: NgxPermissionsService) {
  }

  ngOnInit(): void {
    if (this.item.permissEnabled?.length > 0) {
      this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
        this.isEnabled = enabled;
      });
    } else {
      this.isEnabled = true;
    }

    this.findImageSize();
  }

  findImageSize() {
    const img = new Image();
    if (this.item.image) {
      this.item.image.subscribe((path) => {
        if (path) {
          img.src = path
          this.onLoad(img);
        }
      }, () => {

      });
    } else {
      console.warn('NO IMAGE');
    }

  }
  private onLoad(img) {
    img.onload = () => {
      if (img.height > 35) {
        const c = 35 / img.height;
        const wt = img.width * c;
        const formatted = Math.trunc(wt * 100) / 100
        if (formatted > 140) {
          this.enableFullSize = true;
        }
      }
    }
  }
}
